import React, { useState, useRef, useEffect } from "react";
import { Slider } from "primereact/slider";
import { Tooltip } from "primereact/tooltip";
import "primereact/resources/themes/saga-blue/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import "primeflex/primeflex.css"; // Flex layout
import "./CustomSlider.scss"; // Custom CSS for alignment

const CustomSlider = ({ name, options, value, onChange, onSlideEnd }) => {
    const sliderContainerRef = useRef(null);

    // Désactiver le contrôle clavier avec fleches
    useEffect(() => {
        const container = sliderContainerRef.current;
        if (!container) return;

        const handleKeyDown = (e) => {
            if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        const handles = container.querySelectorAll(".p-slider-handle");
        handles.forEach(handle => handle.addEventListener("keydown", handleKeyDown));

        return () => {
            handles.forEach(handle => handle.removeEventListener("keydown", handleKeyDown));
        };
    }, []);

    const handleValueChange = (newValue) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    const handleStepClick = (stepValue) => {
        handleValueChange(stepValue);
        onSlideEnd(stepValue);
    };

    const renderStepMarks = () => {
        const marks = [];
        const nbSteps = (options.max-options.min)/options.step;
        for (let i = options.min; i <= options.max; i += options.step) {
            const left = ((i - options.min) / (options.max - options.min)) * 100;
            marks.push(
                <>
                    {(nbSteps <= 12) && (
                        <div key={"mark"+i}
                             className="step-mark"
                             style={{left: `${left}%`}}
                             onClick={() => handleStepClick(i)}
                        />
                    )}
                </>
            );
        }
        marks.push(
            <div className="step-labels">
                <div className="step-label left" onClick={() => handleStepClick(options.min)}>
                    {options.labelMin}
                </div>
                <div className="step-label right" onClick={() => handleStepClick(options.max)}>
                    {options.labelMax}
                </div>
            </div>
        );
        return marks;
    };

    return (
        <div className="custom-slider-container" ref={sliderContainerRef}
             style={options.width ? {width: `${options.width}`} : {width: `default`}}>
            {/* Horizontal Slider */}
            <div className="slider-wrapper">
                <Tooltip
                    target={`.slider-${name} .p-slider-handle`}
                    content={`${options.symbolPrefix}${value}${options.symbolSuffix}`} // Add symbol here
                    position="top"
                    autoHide={false}
                    event="both"
                    hideEvent="none"
                />
                <Slider
                    value={value}
                    min={options.min}
                    max={options.max}
                    step={options.step}
                    onChange={(e) => {handleValueChange(e.value)}}
                    onSlideEnd={(e) => onSlideEnd(e.value)}
                    className={`slider-${name} horizontal-slider`}
                />
                {renderStepMarks()}
            </div>
        </div>
    );
};

export default CustomSlider;
